module.exports = __webpack_public_path__ + "img/file-earmark-text-fill.52bac3c0.svg";